import { render, staticRenderFns } from "./strategyArea.vue?vue&type=template&id=ffdbab08&"
import script from "./strategyArea.vue?vue&type=script&lang=js&"
export * from "./strategyArea.vue?vue&type=script&lang=js&"
import style0 from "./strategyArea.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports